import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-by-product-gatepass-billing-preview',
  templateUrl: './by-product-gatepass-billing-preview.component.html',
  styleUrls: ['./by-product-gatepass-billing-preview.component.scss']
})
export class ByProductGatepassBillingPreviewComponent implements OnInit {

  product_list = [];
  total_price = null;
  constructor(public dialogRef: MatDialogRef<ByProductGatepassBillingPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data, private httpService: HttpService, private global: GlobalService) {
      console.log(data)
      this.product_list = data['product_data']['product_list']
      this.total_price = data['product_data']['total_price']
    }

  finalizeCalled() {
    let data_dict = {
      'order_sale_group_id': this.data['by_sale_group_id'],
      'business_code': this.data['business_code'],
      'product_list': this.product_list,
      'total_price': this.total_price,
      'return_product_list': this.data['return_product_list']
    }
    console.log(data_dict);
    this.httpService.returnGRNAndOrderToMainEmployeeOrder(data_dict).subscribe((data) => {
      console.log(data);
      this.closeComponent(true);
    }, (error) => {
      this.closeComponent(false);
      console.error(error);
    });
  }

  closeComponent(data: any) {
    this.dialogRef.close(data);
  }
  ngOnInit() {
  }

}
